import React, { FC, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { ContactApi } from "../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../services/Api/api";

interface Props {
	isShown: boolean;
	onHide: () => void;
	value: string;
	onSave: (item: ContactApi) => void;
}

const CreateContactModalForm: FC<Props> = ({ isShown, onHide, value, onSave }) => {
	const form = useForm<ContactApi>({
		criteriaMode: "all",
		defaultValues: { name: value },
	});
	const { t } = useTranslation();
	const {
		register,
		handleSubmit,
		setError,
		formState: { errors },
	} = form;
	const { addSuccessFlash, addFlash } = useFlash();
	const [loading, setLoading] = useState<boolean>(false);

	const onSubmit = handleSubmit(async (data: ContactApi) => {
		setLoading(true);
		try {
			const res = await api.organization().createContact(data, { parse_name: true });
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			onSave(res);
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal onHide={onHide} show={isShown}>
			<Form key="contact-modal-form" onSubmit={onSubmit}>
				<Modal.Header>
					<Modal.Title>{t("modules.document.field.new_contact.title")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormInput
						label={t("modules.document.field.name_or_tax_id_no.title")}
						register={register}
						name="name"
						errors={errors}
					/>
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading variant="primary" type="submit" loading={loading} onClick={onSubmit}>
						{t("common.action.save", { ns: "lib" })}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("common.action.cancel", { ns: "lib" })}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

export default CreateContactModalForm;
